import React, { useState, useEffect } from 'react';
import swal from 'sweetalert';
import { ECMID } from '../../../constants';
import { Link, useLocation } from 'react-router-dom';
import Loader from '../../../component/Loader/Loader';
import Breadcrumb from '../../../component/Breadcrumb';
import FormNumberField from '../../../component/NumberInput';
import { getReceiveMessageMappingData } from '../../../api/mappingApi';
import { Grid, Typography, Box, TextField, Button, FormControl, InputLabel, Select, MenuItem, FormHelperText } from '@mui/material';
import TextInput from '../../../component/TextInput';
import CanFilterDropDown from '../../../component/CanFilterDropDown';


const ECUReceiveMessageEdit = () => {
    const location                                      = useLocation();
    const [showLoader, setShowLoader]                   = useState(false);
    const [sheetMappingData, setSheetMappingData]       = useState([]);
    const [fields,setFields]                            = useState({
        Addr            :   null,
        ECMID           :   null,
        PGN             :   null,
        StartByte       :   null,
        StartBit        :   null,
        Len             :   null,
        Scaling         :   null,
        Offset          :   null,
        MxVldScaledVal  :   null,
        DType           :   null,
        Persistent      :   null,
        SPN             :   null,
        Desc            :   null,
        CST             :   null
    })

    useEffect(()=> {
        if(location.state?.addressId !== '' && location.state?.addressId !== undefined){
            getMappingData();
        }
    },[location.state?.addressId]);

    const getMappingData = async () => {
        setShowLoader(true);
        const mappingData = await getReceiveMessageMappingData(location.state?.addressId);
        setShowLoader(false);
        setSheetMappingData(mappingData);
        // Object.keys(fields)?.map((keyName) => {
        //     //console.log('keyName',keyName)
        //     setFields((prevState) => ({...prevState, [keyName]: mappingData[keyName]}))
        // })
        setFields((prevState) => ({...prevState, 'Addr': mappingData?.Addr}))
    }

    const changeHandler = (e) => {
        let value = e.target.name === 'PGN' ?  e.target.value.replace(/\D/g, "") : e.target.value;
        let name  = e.target.name;
        setFields((prevState) => ({...prevState, [name]: e.target.name !== 'PGN' ? value : isNaN(parseInt(value)) ? '' : parseInt(value)}))
    }

    const handleBlurUpdate = (name,value) => {
        let finalVal;
        if(name === 'MxVldScaledVal' || name === 'Scaling' || name === 'Offset'){
            const result = decimalValidation(name,value);
            if(result){
                swal("Oops!", "Please use Float value for Scaling, Offset and MxVldScaledVal!", "error");
            }
            if(value % 1 === 0){
                console.log('i m here')
                value = Number(value) === 0 ? 0.000001 : parseFloat(value) + 0.000001;
            }
            console.log('value',value)
            finalVal = value ? parseFloat(value) : '';
        } else {
            finalVal = parseInt(value);
        }
        setFields((prevState) => ({...prevState, [name]: finalVal}));
        // setFields((prevState) => ({...prevState, [name]: isNaN(parseFloat(value)) ? '' : parseFloat(value)}));
    } 


    const decimalValidation = (name,value) => {
        // console.log('name',name);
        // console.log('value',value)
        let validationArray = ['MxVldScaledVal','Scaling','Offset'];
        if(validationArray.includes(name) && value !== '' && value?.toString()?.indexOf('.') === -1) {
            return true;
        } 
        return false;
    }

    const handleSubmit = () => {
        // const isEmpty = !Object.values(fields).every(val => val !== null && val !== '');
        // if(isEmpty){
        //     swal("Oops!", "Please fill required fields!", "error");
        //     return false;
        // }

        const notEmpty = Object.values(fields).filter(val => val !== null && val !== '').length;
        if(notEmpty <= 1){
            swal("Oops!", "Please update atleast one field!", "error");
            return false;
        }

        let existingReceiveMessages = JSON.parse(localStorage.getItem('ECUReceiveMessages'));
        if(existingReceiveMessages == null) existingReceiveMessages = [];
        let isExist = false;
        let removeNullKeyFields     = Object.fromEntries(Object.entries(fields).filter(([_, v]) => v != null));

        let valdationStatus = false;
        Object.keys(removeNullKeyFields).forEach(function(key) {
            const result = decimalValidation(key,removeNullKeyFields[key]);
            //console.log('result',result)
            if(result){
                valdationStatus = true;
            }        
        });

        if(valdationStatus){
            swal("Oops!", "Please use Float value for Scaling, Offset and MxVldScaledVal!", "error");
            return false;
        }

       // return false;

        if(existingReceiveMessages  != null && existingReceiveMessages.length > 0){
            existingReceiveMessages =  existingReceiveMessages?.map((message) =>  {
            if(message.Addr === removeNullKeyFields.Addr){
              isExist = true;
              return {...message,...removeNullKeyFields}
            } else {
              return message;
            }
          });
        } 
        if(!isExist){
            existingReceiveMessages.push(removeNullKeyFields);
        }
        localStorage.setItem('ECUReceiveMessages',JSON.stringify(existingReceiveMessages));
        swal({
            title: "Success",
            text: 'ECUID Receive Message updated successfully.',
            icon: "success",
        })
    }

    //console.log('fields',fields)

    return (
        <>
            {showLoader && 
                <Loader />
            }
            <Breadcrumb title='Edit ECU Receive Messages'>
                <Typography component={Link} to="/" variant="subtitle2" color="primary" className="link-breadcrumb">
                    Dashboard
                </Typography>
                <Typography component={Link} to={location.pathname.includes('mapping') ? '/mapping/can/receive-messages' : '/can/receive-messages'} variant="subtitle2" color="primary" className="link-breadcrumb">
                ECUReceiveMessages
                </Typography>
                <Typography variant="subtitle2" color="inherit" className="link-breadcrumb">
                    Edit 
                </Typography>
            </Breadcrumb>
            <Box component="section">
                <Grid className="contentBox">
                    <Grid className="modbusButtons" container direction="row" display={'flex'} justifyContent={'flex-end'}>
                        <Grid item>
                            <Button
                                component={Link} 
                                to={location.pathname.includes('mapping') ? '/mapping/can/receive-messages' : '/can/receive-messages'}
                                variant="contained"
                                size="small"
                                color="primary"
                                sx={{mr:3}}
                            >Back 
                            </Button>
                        </Grid>
                    </Grid>
                    
                    <Grid container direction="row" spacing={{ xs: 0,sm:2 }}>
                        <Grid item xs={12} sm={4} md={4}>
                            <TextField
                                fullWidth
                                margin="dense"
                                id="Addr"
                                label="Address"
                                name="Addr"
                                value={fields?.Addr || ""}
                                disabled={true}
                             />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormControl
                                margin="dense"
                                fullWidth
                            >
                                <InputLabel id="demo-simple-select-standard-label">ECMID</InputLabel>
                                <Select
                                    labelId="demo-simple-select-standard-label"
                                    id="demo-simple-select-standard"
                                    sx={{
                                        "&:focus": {
                                            backgroundColor: "#ffffff"
                                        }
                                    }}
                                    label="ECMID"
                                    value={fields?.ECMID ||  fields.ECMID === 0 ? fields.ECMID : '' || ""}
                                    onChange={changeHandler}
                                    name="ECMID"
                                   // error={fields.ECMID === "" || fields?.ECMID === null}
                                >
                                    <MenuItem value="">Select ECMID</MenuItem>
                                    {ECMID?.map((opt) => (
                                        <MenuItem key={opt.value} value={opt.value}>{opt.name}</MenuItem>
                                    ))}
                                </Select>
                                {/* <FormHelperText sx={{color:"#d32f2f"}} >{fields.ECMID === "" || fields?.ECMID === null ? "Required Field!" : false}</FormHelperText> */}
                            </FormControl>
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <TextInput
                                label="PGN"
                                name="PGN"
                                value={fields?.PGN  ? fields.PGN  : fields?.PGN === '' ? fields?.PGN : sheetMappingData?.PGN  || ""}    
                                changeHandler={changeHandler}
                                //error={true}
                                //helperText={true}
                                width={true}
                            />
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={{ xs: 0,sm:2 }}>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                className='fieldFullWidth numberInputField'
                                margin="dense"
                                id="StartByte"
                                label="StartByte"
                                name="StartByte"
                                value={fields?.StartByte  ? fields.StartByte  : fields?.StartByte === '' ? fields?.StartByte : sheetMappingData?.StartByte  || ""} 
                                //value={fields?.StartByte ? fields.StartByte : ""}
                                onBlurUpdate={handleBlurUpdate}
                                // error={true}
                                // helperText={true}
                                type="int"
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                className='fieldFullWidth numberInputField'
                                margin="dense"
                                id="StartBit"
                                label="StartBit"
                                name="StartBit"
                                value={fields?.StartBit  ? fields.StartBit  : fields?.StartBit === '' ? fields?.StartBit : sheetMappingData?.StartBit  || ""}
                                //value={fields?.StartBit ? fields.StartBit : ""}
                                onBlurUpdate={handleBlurUpdate}
                                // error={true}
                                // helperText={true}
                                type="int"
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                className='fieldFullWidth numberInputField'
                                margin="dense"
                                id="Len"
                                label="Len"
                                name="Len"
                                value={fields?.Len  ? fields.Len  : fields?.Len === '' ? fields?.Len : sheetMappingData?.Len  || ""}
                               // value={fields?.Len ? fields.Len : ""}
                                onBlurUpdate={handleBlurUpdate}
                                // error={true}
                                // helperText={true}
                                type="int"
                            />
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={{ xs: 0,sm:2 }}>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                className='fieldFullWidth numberInputField'
                                margin="dense"
                                id="Scaling"
                                label="Scaling"
                                name="Scaling"
                                value={fields?.Scaling  ? fields.Scaling  : fields?.Scaling === '' ? fields?.Scaling : sheetMappingData?.Scaling  || ""}
                                //value={fields?.Scaling ? fields.Scaling : ""}
                                onBlurUpdate={handleBlurUpdate}
                                // error={true}
                                // helperText={true}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                className='fieldFullWidth numberInputField'
                                margin="dense"
                                id="Offset"
                                label="Offset"
                                name="Offset"
                                value={fields?.Offset  ? fields.Offset  : fields?.Offset === '' ? fields?.Offset : sheetMappingData?.Offset  || ""}
                                //value={fields?.Offset ? fields.Offset : ""}
                                onBlurUpdate={handleBlurUpdate}
                                // error={true}
                                // helperText={true}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                className='fieldFullWidth numberInputField'
                                margin="dense"
                                id="MxVldScaledVal"
                                label="MxVldScaledVal"
                                name="MxVldScaledVal"
                                value={fields?.MxVldScaledVal  ? fields.MxVldScaledVal  : fields?.MxVldScaledVal === '' ? fields?.MxVldScaledVal : sheetMappingData?.MxVldScaledVal  || ""}
                                //value={fields?.MxVldScaledVal ? fields.MxVldScaledVal : ""}
                                onBlurUpdate={handleBlurUpdate}
                                // error={true}
                                // helperText={true}
                            />
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={{ xs: 0,sm:2 }}>
                        <Grid item xs={12} sm={4} md={4}>
                            <TextInput
                                id="DType"
                                label="DType"
                                name="DType"
                                value={fields?.DType  ? fields.DType  : fields?.DType === '' ? fields?.DType : sheetMappingData?.DType  || ""}
                                changeHandler={changeHandler} 
                                //error={true}
                                width={true}
                                //helperText={true}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <CanFilterDropDown 
                                label="Persistent"
                                name="Persistent"
                                value={fields?.Persistent  ? fields.Persistent  : fields?.Persistent === '' || fields?.Persistent === 0 ? fields?.Persistent : sheetMappingData?.Persistent  || ""}
                                changeHandler={changeHandler}
                                width={true}
                                // error={true}
                                // helperText={true}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={4}>
                            <FormNumberField
                                className='fieldFullWidth numberInputField'
                                margin="dense"
                                id="SPN"
                                label="SPN"
                                name="SPN"
                                value={fields?.SPN  ? fields.SPN  : fields?.SPN === '' ? fields?.SPN : sheetMappingData?.SPN  || ""}
                                // value={fields?.SPN ? fields.SPN : ""}
                                onBlurUpdate={handleBlurUpdate}
                                // error={true}
                                // helperText={true}
                                type="int"
                            />
                        </Grid>
                    </Grid>
                    <Grid container direction="row" spacing={{ xs: 0,sm:2 }}>
                        <Grid item xs={12} sm={6} md={6}>
                            <TextField
                                //sx={{mt: { xs:'24px',sm:'8px',md:'8px'}}}
                                fullWidth
                                margin="dense"
                                id="Desc"
                                label="Desc"
                                name="Desc"
                                value={fields?.Desc  ? fields.Desc  : fields?.Desc === '' ? fields?.Desc : sheetMappingData?.Desc  || ""}
                                //value={fields?.Desc || ""}
                                //multiline
                                //rows={4}
                                onChange={changeHandler}
                                //error={fields.Desc === "" || fields.Desc === null}
                                //helperText={fields.Desc === "" || fields.Desc === null ? "Required Field!" : false}
                            />
                        </Grid>
                        <Grid item xs={12} sm={6} md={6}>
                            <TextField
                                fullWidth
                                margin="dense"
                                id="CustomText"
                                label="Custom Text"
                                name="CST"
                                value={fields?.CST  ? fields.CST  : fields?.CST === '' ? fields?.CST : sheetMappingData?.CST  || ""}
                                onChange={changeHandler}
                            />
                        </Grid>
                    </Grid>
                    <Grid item xs={6} sm={4} md={3}>
                        <Grid container direction="row" spacing={1} display={'flex'} justifyContent={'flex-start'}>
                            <Grid item>
                                <Button
                                    onClick={handleSubmit}
                                    variant="contained"
                                    size="medium"
                                    color="primary"
                                    sx={{mt:2}}
                                >Submit
                                </Button>
                            </Grid>
                            <Grid item >
                                <Button
                                    component={Link} 
                                    to={'/can/receive-messages'}
                                    variant="contained"
                                    size="medium"
                                    color="error"
                                    sx={{mt:2}}
                                >Cancel
                                </Button>
                            </Grid>
                        </Grid> 
                    </Grid> 
                </Grid>
            </Box>
        </>
    );
};

export default ECUReceiveMessageEdit;
